export const cmsBase    = 'https://www.headless-cms.io/api/'

export const uiBase  = '/'
